<main role="main" class="not-home-page">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner"><img src="" alt="" /></div>
          <app-breadcrumb></app-breadcrumb>
          <h2>{{ "passerelle.titre" | translate }}</h2>
        </div>
        <div class="col-md-3 side-bar">
          <div class="selected-item">      </div> 
          <nav id="sidebar">
            <app-statique-menu
              [lg]="currentLg"
              [cururl]="'/publications/newsletter'"
            ></app-statique-menu>
          </nav>
        </div>
        <div class="col-md-9">
          <section class="content-side">
            <div class="container">
              <div class="row">
                <div class="col-lg-10 col-md-10 col-s-12">
                  <div class="row">
                    <div class="col-12">
                      <p>
                        {{ bloc.Contenu }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                      <p>{{ "passerelle.email" | translate }} :</p>
                    </div>
                    <div class="col-lg-6 col-md-6 col-s-12">
                      <input [(ngModel)]="nwMail" type="text" name="Email" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                      <p>{{ "passerelle.choix" | translate }} :</p>
                    </div>
                    <div class="col-lg-6 col-md-6 col-s-12">
                      <input
                        type="radio"
                        id="inscriptionRd0"
                        class="optionClass"
                        name="inscriptionRd"
                        [value]="true"
                        [(ngModel)]="inscription"
                      />
                      <label
                        class="toggle-button"
                        style="padding-right: 10px"
                        for="inscriptionRd0"
                        >{{ "passerelle.inscription" | translate }}</label
                      >
                      <input
                        type="radio"
                        id="inscriptionRd1"
                        name="inscriptionRd"
                        class="optionClass"
                        [value]="false"
                        [(ngModel)]="inscription"
                      />
                      <label
                        class="toggle-button"
                        style="padding-right: 10px"
                        for="inscriptionRd1"
                        >{{ "passerelle.desinscription" | translate }}</label
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-s-12" class="titleField">
                      <p>{{ "passerelle.codeSecurite" | translate }} :</p>
                    </div>
                    <div class="col-lg-6 col-md-6 col-s-12">
                      <div style="display: inline-flex; height: 45px">
                        <input type="text" id="cpatchaTextBox" name="text" />
                        <div class="captchaClass" id="captcha"></div>
                        <a href="javascript:void(0)" (click)="createCaptcha()">
                          <img
                            src="/assets/css/img/reloading.gif"
                            style="
                              width: 35px;
                              height: 35px;
                              padding: 5px;
                              margin: 5px;
                            "
                            alt="reload captcha"
                            Title="Reload captcha"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-6 col-md-6 col-s-12"
                      class="titleField"
                    ></div>
                    <div class="col-lg-6 col-md-6 col-s-12">
                      <div class="btn_form">
                        <button
                          style="margin: 10px"
                          class="btn btn-primary"
                          (click)="addInscription()"
                          type="button"
                        >
                        {{  "passerelle.valider" | translate}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
             
                <div class="col-10">
                <mat-expansion-panel *ngFor="let item of annees; let index=index" (opened)="openTab[index]"
                    (closed)="panelOpenState = false" style="margin-top: 5px;">
                    <mat-expansion-panel-header style="background-color: #00bade; ">
                    <mat-panel-title class="accordeonTitle">
                     <strong> Publications  {{item}}</strong> 
                    </mat-panel-title>
                  
                    </mat-expansion-panel-header>
                    <ul *ngFor="let news of passerelles | FilterAnnee:item ">
                        <li style="margin-top: 5px;">
                        <strong> <a href="javascript:void(0)" (click)="downloadTarget(news.url)">{{"La Passerelle " + news.Title }}</a></strong> 
                        </li>
                      </ul>
                    <ul *ngFor="let news of newsLetters | FilterAnnee:item ; let index=index ">
                        <li>
                        <strong> <a href="javascript:void(0)" id="{{'new' + index + item }}" (click)="chargeFancyBox(news.url)">{{ news.Title }}</a></strong> 
                        </li>
                      </ul>
                </mat-expansion-panel>
            
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</main>
<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  style="background-color: #84919ca1;" aria-hidden="true">
  <div class="modal-dialog" role="document" style="max-width: 70%;">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <!-- 16:9 aspect ratio -->
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" src="" id="page" allowscriptaccess="always" ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>